module.exports = __webpack_public_path__ + "static/recruiting-91a60380a0b918f09c478b279b3c030d.gif";